<template>
    <Portal>
        <Announcement/>
        <CRow class="d-flex justify-content-center align-items-center mb-4">
            <CCol :xl="store.myUser.allowOnlineTrainingBetaAccess ? 7 : 6">
                <CRow class="d-flex justify-content-center align-items-center mb-0 mb-sm-2">
                    <CCol col="12" md="5" class="mb-2 mb-sm-0">
                        <CButtonGroup size="sm" class="video__uploader-btn">
                            <CButton @click="setFeedType('my-trainings')"
                                     :disabled="!hasMyTrainings"
                                     :class="(feedType === 'my-trainings' ? 'btn-dark noblur' : 'btn-secondary noblur') + (feedType === 'training' ? ' buttonDividerRight' : '')"
                            >My videos
                            </CButton>
                            <CButton @click="setFeedType('feed')"
                                     :class="feedType === 'feed' ? 'btn-dark noblur' : 'btn-secondary noblur' + (feedType === 'training' ? ' buttonDividerLeft' : '')"
                            >Public
                            </CButton>
                            <CButton :href="onlineTrainingHref"
                                     :class="'btn-secondary noblur'"
                                     v-if="store.myUser.allowOnlineTrainingBetaAccess"
                            >Real-time
                            </CButton>
                        </CButtonGroup>

                        <CButton
                            @click="filterWindowToggle"
                            size="sm"
                            class="ml-2 filter-btn"
                            :class="'btn-secondary noblur'"
                        >Search <img src="../assets/img/filter.svg" width="15" alt="">
                        </CButton>
                    </CCol>
                    <CCol col="12" md="7" class="video__uploader-block">
                        <div>
                            <input
                                v-show="false"
                                type="file"
                                ref="videoInput"
                                @change="onMainUploadButtonVideoSelected"
                            >
                            <CButton
                                @click.prevent="$refs.videoInput.click()"
                                color="info"
                                type="submit"
                                :disabled="isOverAnalysisLimit()"
                                v-c-tooltip="isOverAnalysisLimit() ? 'You have reached your monthly analysis limit: ' + getAnalysisCount() + ' of ' + getAnalysisLimit() : ''"
                            >
                                Upload lateral video
                            </CButton>
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <TrainingConfiguration v-for="newTrainingId in newTrainingsIds"
                               :key="newTrainingId"
                               :videoFile="newTrainingsOpts[newTrainingId].videoFile"
                               @deleteThis="deleteNewTraining(newTrainingId)"
                               @addOneMore="addNewTraining(newTrainingId)"
                               @submitted="onNewTrainingSubmitted(newTrainingId)"
        />

        <TrainingFilter v-if="filterWindowIsOpened || filter.length" v-show="filterWindowIsOpened"
                        @hideFilter="filterWindowToggle"
                        @applyFilter="applyFilter"
        />

        <CRow class="justify-content-center mt-5 mb-5" v-if="feedIsLoading || submittedVideoIsLoading">
            <Spinner/>
        </CRow>

        <template v-if="!feedIsLoading && trainingsIds">
            <TrainingBlock v-for="(trainingId, index) in trainingsIds"
                           :key="'v' + trainingId"
                           :training="trainings[trainingId]"
                           :doPreload="index < 2"
                           @deleteThis="deleteTraining(trainingId)"
                           @updateThis="graphqlUpdater.forceRun()"
                           @uploadNewVideoOnErrorMsgClick="uploadNewVideoOnErrorMsgClick()"
                           :feedType="feedType"
            />
        </template>
        <template v-if="!feedIsLoading && trainingsIds.length === 0">
            <CRow><CCol class="text-center">There are no videos with this filter criterion.</CCol></CRow>
        </template>

        <template v-if="feedType !== 'Training'">
            <infinite-loading v-if="firstBatchWasLoaded" :identifier="infiniteScrollId"
                              @infinite="infiniteScrollHandler" :forceUseInfiniteWrapper="'window'"
                              :distance="5100"
            >
                <template slot="spinner">
                    <CRow v-if="!(feedIsLoading || submittedVideoIsLoading)" class="justify-content-center mt-5 mb-5">
                        <Spinner/>
                    </CRow>
                    <div v-else></div>
                </template>
                <template slot="no-more">
                    <div></div>
                </template>
                <template slot="no-results">
                    <div></div>
                </template>
            </infinite-loading>
        </template>
    </Portal>
</template>
<script>
    import Portal from '@/components/layouts/Portal'
    import TrainingConfiguration from '@/components/TrainingConfiguration'
    import TrainingBlock from '@/components/TrainingBlock'
    import TrainingFilter from '@/components/TrainingFilter'
    import Announcement from '@/components/Announcement'
    import gql from 'graphql-tag'
    import {apolloClient} from '@/plugins/apollo'
    import {getQueries, GraphqlUpdater, printSeparated} from '@/scripts/utils'
    import {getTrainingQueryBody} from '@/scripts/queries'
    import {store} from '@/scripts/globals'
    import Spinner from '@/components/Spinner'
    import InfiniteLoading from 'vue-infinite-loading'
    import {getTrainingParamsArrForUrl} from "@/scripts/training-utils";
    import router from "@/plugins/router";
    import {isOverAnalysisLimit, getAnalysisLimit, getAnalysisCount} from "@/scripts/auth-utils";


    const fetchTrainingQueries = getQueries('trainingsById', 'TrainingType', getTrainingQueryBody())

    const scrollStep = 7;

    export default {
        components: {
            Portal,
            TrainingConfiguration,
            TrainingBlock,
            TrainingFilter,
            Spinner,
            InfiniteLoading,
            Announcement
        },
        data() {
            let feedType = this.$route.name
            return {
                store,
                graphqlUpdater: new GraphqlUpdater(
                    {
                        targetObjIdsGetter: null,
                        fetchQuery: gql(fetchTrainingQueries.fetchQuery),
                        fetchUpdateQuery: gql(fetchTrainingQueries.fetchQuery),
                        updatedDataSetterAsync: this.updatedDataSetter,
                        autoUpdatePeriodMs: 3000,
                        name: 'Trainings'
                    }),
                newTrainingsIds: [],
                newTrainingsOpts: {},
                newTrainingsCounter: 1,
                showFirstN_Trainings: scrollStep,
                trainings: {},
                trainingsIds: [],
                hasMyTrainings: true,
                feedIsLoading: true,
                submittedVideoIsLoading: false,
                infiniteScrollId: new Date(),
                firstBatchWasLoaded: false,
                feedType,
                onlineTrainingHref: router.resolve({name: 'online-training'}).href,
                filterWindowIsOpened: false,
                filter: {},
                isOverAnalysisLimit,
                getAnalysisLimit
            }
        },
        methods: {
            getAnalysisCount,
            refreshInfiniteScroll() {
                this.infiniteScrollId = new Date()
            },
            async infiniteScrollHandler($state) {
                if (this.trainingsIds.length === this.showFirstN_Trainings) {
                    this.showFirstN_Trainings += scrollStep
                    await this.graphqlUpdater.forceRun()
                    $state.loaded()
                    // alert(0) // for debug
                } else {
                    $state.complete()
                    // alert(1) // for debug
                }
            },
            uploadNewVideoOnErrorMsgClick() {
                this.$refs.videoInput.click()
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
            async deleteTraining(trainingId) {
                let mutation = gql`
                     mutation {
                                deleteTraining(trainingId: ${trainingId}) {
                                    success
                                }
                            }
                `
                await apolloClient.mutate({mutation})
                await this.graphqlUpdater.forceRun()
            },
            async onNewTrainingSubmitted(newTrainingId) {
                this.deleteNewTraining(newTrainingId)
                if (this.feedType !== 'my-trainings') {
                    await this.setFeedType('my-trainings')
                } else {
                    this.submittedVideoIsLoading = true
                    await this.graphqlUpdater.forceRun()

                    this.submittedVideoIsLoading = false
                    this.refreshInfiniteScroll()
                }
            },
            onMainUploadButtonVideoSelected(evt) {
                this.addNewTraining(null, evt.target.files[0])
                this.$refs.videoInput.value = null
            },
            addNewTraining(parentTrainingId, videoFile) {
                let trainingId = this.newTrainingsCounter
                this.newTrainingsCounter += 1
                this.newTrainingsOpts[trainingId] = {videoFile}
                if (parentTrainingId)
                    this.newTrainingsIds.splice(this.newTrainingsIds.indexOf(parentTrainingId) + 1, 0, trainingId)
                else
                    this.newTrainingsIds.unshift(trainingId)
            },
            deleteNewTraining(newTrainingId) {
                this.newTrainingsIds = this.newTrainingsIds.filter(value => value !== newTrainingId)
                delete this.newTrainingsOpts[newTrainingId]
            },
            async updatedDataSetter(trainings, ids) {
                if (this.feedType === 'training' && ids.length === 0) {
                    let trainingId = this.$route.params.trainingId
                    let query = gql`
                            {
                                trainingStatus (trainingId: ${trainingId})
                            }
                        `
                    // noinspection ES6ConvertVarToLetConst
                    var Fcontext = this

                    // eslint-disable-next-line
                    async function F() {
                        let qRes = await apolloClient.query({query})
                        let res = qRes['data']['trainingStatus']
                        let training = {
                            id: trainingId,
                            isNotFound: res === 'NotFound',
                            isNotAllowed: res === 'Exists',
                            isDeleted: res === 'Deleted',
                            isNotAccessible: true
                        }
                        Fcontext.trainings = {}
                        Fcontext.trainings[trainingId] = training
                        Fcontext.trainingsIds = [trainingId]
                    }

                    await F()
                } else {
                    this.trainings = trainings
                    this.trainingsIds = ids
                }
            },
            setGraphqlUpdaterTargetObjectIdsGetter() {
                this.graphqlUpdater.targetObjIdsGetter = {
                    'my-trainings': this.myTrainingsIdsGetter,
                    'training': this.trainingIdGetter,
                    'feed': this.publicTrainingsIdsGetter
                }[this.feedType]
            },
            async myTrainingsIdsGetter() {
                return this.idsGetter('MyTrainings');
            },
            async publicTrainingsIdsGetter() {
                return this.idsGetter('Public');
            },
            async idsGetter(type) {
                let boatTypes = this.filter.crew && this.filter.crew.length > 0 ? JSON.stringify(this.filter.crew) : '',
                    strokes = this.filter.strokes_min*1 && (this.filter.strokes_max*1 - this.filter.strokes_min*1) >= 0
                        ? JSON.stringify([this.filter.strokes_min * 1, this.filter.strokes_max * 1])
                        : '',
                    equipmentType = this.filter.type && this.filter.type !== '' ? this.filter.type : '',
                    qRes = await apolloClient.query({
                        query:
                            gql`
                                {
                                    trainings (
                                        listNames: [${store.showAllVideosInFeed ? 'All' : type}],
                                        firstN: ${this.showFirstN_Trainings},
                                        prefetchIdsOnly: true,
                                        ${equipmentType ? 'equipmentType: "' + equipmentType + '",' : ''}
                                        ${boatTypes ? 'boatTypes: ' + boatTypes + ',' : ''},
                                        ${strokes ? 'strokes: ' + strokes + ',' : ''}
                                        ${this.filter.videoQuality?.value ? `minFootageQuality: ${this.filter.videoQuality?.value},` : ''}
                                    )
                                    {
                                        id
                                    }
                                }
                                `
                        },
                    )
                // noinspection UnnecessaryLocalVariableJS
                let res = qRes.data['trainings'].map(x => x.id)
                return res
            },
            async trainingIdGetter() {
                return [this.$route.params.trainingId]
            },
            async setFeedType(feedType, trainingId) {
                await this.$router.push({
                    name: feedType,
                    params: feedType === 'training' ? {
                        trainingId: trainingId,
                        trainingParams: getTrainingParamsArrForUrl(this.trainings[trainingId], this.store.myUser)
                    } : {}
                })
            },
            onRouteChanged(newRoute, prevRoute) {
                if (newRoute.name !== prevRoute.name) {
                    this.feedType = this.$route.name
                    this.reloadFeed();
                }
            },
            async reloadFeed() {
                this.feedIsLoading = true
                this.feedType = this.$route.name
                this.showFirstN_Trainings = scrollStep

                this.setGraphqlUpdaterTargetObjectIdsGetter()
                await this.graphqlUpdater.forceRun()
                this.feedIsLoading = false
                this.refreshInfiniteScroll()
            },
            filterWindowToggle() {
                if (this.filterWindowIsOpened) {
                    this.applyFilter({});
                }
                this.filterWindowIsOpened = !this.filterWindowIsOpened;
            },
            applyFilter(filter) {
                this.filter = filter;
                this.reloadFeed();
            },
        },
        async beforeDestroy() {
            await this.graphqlUpdater.stop()
        },
        async created() {
            this.setGraphqlUpdaterTargetObjectIdsGetter()
            await this.graphqlUpdater.start()
            this.firstBatchWasLoaded = true
            this.feedIsLoading = false
            this.hasMyTrainings = store.myUser.hasMyTrainings
        },
        watch: {
            'store.myUser.hasMyTrainings': function (hasMyTrainings) {
                this.hasMyTrainings = hasMyTrainings
                if (!this.hasMyTrainings && this.feedType === 'my-trainings')
                    this.setFeedType('feed')
            },
            'trainingsIds': function (newTrainingsIds, oldTrainingIds) {
                if (this.feedType !== 'training' && JSON.stringify(newTrainingsIds) !== JSON.stringify(oldTrainingIds)) {
                    this.refreshInfiniteScroll()
                }
            },
            '$route': function (newRoute, prevRoute) {
                this.onRouteChanged(newRoute, prevRoute)
            }
        }
    }
</script>

<style lang="scss">
    .video__uploader-btn {
        padding-left: 1.25em;
    }

    .video__uploader-btn .active {
        color: #4f5d73;
        background-color: #b2b8c1;
        border-color: #abb1bc;
    }

    @media screen and (max-width: 768px) {
        .video__uploader {
            &-btn {
                padding-left: 0;
            }

            &-block {
                text-align: center;

                button {
                    font-size: 0.76562rem;
                }
            }
        }
        .filter-btn {
            float: right;
        }
    }

    .buttonDividerLeft {
        border-left-color: #BBBBBB !important;
    }

    .buttonDividerRight {
        border-right-color: #BBBBBB !important;
    }
</style>